import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const problems = [{
    // IMAGEN: Persona estresada frente al computador
    image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=150&h=150&fit=crop&crop=faces',
    title: 'ABRUMADO POR LA INFORMACIÓN',
    description: 'Cada día salen 100 herramientas nuevas. Intentas aprenderlas, pero terminas perdiendo horas en tutoriales sin aplicar nada real. Tienes "parálisis por análisis".'
  }, {
    // IMAGEN: Manos cansadas o reloj nocturno
    image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=150&h=150&fit=crop&crop=faces',
    title: 'ESCLAVO DE LO MANUAL',
    description: 'Sigues redactando correos, resumiendo reuniones y creando reportes desde cero. Sientes que trabajas el doble que los demás para conseguir la mitad de resultados.'
  }, {
    // IMAGEN: Persona mirando ventana preocupada
    image: 'https://images.unsplash.com/photo-1618018352910-72bdafdc40a6?w=150&h=150&fit=crop&crop=faces',
    title: 'MIEDO A SER IRRELEVANTE',
    description: 'Ves cómo compañeros más jóvenes avanzan rápido usando IA, mientras tú sientes que tu experiencia vale cada vez menos. Temes quedarte fuera del mercado.'
  }, {
    // NUEVO: Bloqueo creativo / Página en blanco
    image: 'https://images.unsplash.com/photo-1534614971-6be99a7a3ffd?w=150&h=150&fit=crop&crop=faces',
    title: 'SÍNDROME DE LA PÁGINA EN BLANCO',
    description: 'Te quedas mirando el cursor parpadeando por minutos (u horas) sin saber cómo empezar ese correo, ese post o ese informe importante. La creatividad no fluye.'
  }, {
    // NUEVO: Sin tiempo libre
    image: 'https://images.unsplash.com/photo-1531855909289-4b6840615e47?w=150&h=150&fit=crop&crop=faces',
    title: 'TU VIDA PERSONAL NO EXISTE',
    description: 'Cierras la laptop cuando ya es de noche. Te pierdes cenas, gimnasio y momentos importantes por tener que "sacar el trabajo" que se acumuló.'
  }, {
    // NUEVO: Calidad vs Tiempo
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=150&h=150&fit=crop&crop=faces',
    title: 'RESULTADOS MEDIOCRES',
    description: 'Sabes que podrías entregar trabajos de mucha más calidad, pero la falta de tiempo te obliga a entregar "lo justo para cumplir". Eso frena tu ascenso.'
  }];
  return <section className="py-24 relative z-10 bg-[#050505]" data-id="element-177">
      <div className="container mx-auto px-4" data-id="element-178">
        {/* Encabezado */}
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-179">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-180">
            ¿TE SIENTES <span className="text-red-500" data-id="element-181">IDENTIFICADO?</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-182">
            Si marcaste al menos una de estas casillas, el Masterkit IA fue diseñado específicamente para ti.
          </p>
          <div className="h-1 w-24 bg-red-500 mx-auto rounded-full shadow-[0_0_15px_rgba(239,68,68,0.5)] mt-8" data-id="element-183" />
        </div>

        {/* Grid de Problemas */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-184">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          delay: index * 0.1
        }}
        // Tarjeta Manual con diseño "Glass" oscuro
        className="relative group p-8 rounded-2xl bg-white/5 border border-white/10 hover:border-red-500/30 hover:bg-white/[0.07] transition-all duration-300 flex flex-col items-center text-center" data-id="element-185">
              {/* Imagen Circular con Brillo */}
              <div className="relative mb-6" data-id="element-186">
                <div className="w-24 h-24 rounded-full p-1 bg-gradient-to-br from-red-500/20 to-transparent border border-white/10 shadow-[0_0_30px_rgba(239,68,68,0.15)] group-hover:scale-105 transition-transform duration-300" data-id="element-187">
                   <img src={problem.image} alt={problem.title} className="w-full h-full rounded-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-188" />
                </div>
                {/* Icono de alerta flotante */}
                <div className="absolute -top-2 -right-2 bg-[#050505] rounded-full p-1 border border-red-500/30" data-id="element-189">
                   <svg className="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-190">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" data-id="element-191" />
                   </svg>
                </div>
              </div>

              <h3 className="text-xl font-bold text-white mb-4 group-hover:text-red-400 transition-colors" data-id="element-192">
                {problem.title}
              </h3>
              
              <p className="text-gray-400 text-base leading-relaxed" data-id="element-193">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}